import { get, post, del, put } from './client';

const BASE_URL = process.env.REACT_APP_ATLANTIS_URL ?? 'https://dev-api.degentreasures.com/v1';

export const getPromos = async (Authorization = '') => {
  const res = await get(`${BASE_URL}/promos`, {
    Authorization,
  });
  return res?.payload;
};

export const getPromoById = async (promoId, Authorization = '') => {
  const res = await get(`${BASE_URL}/promos/${promoId}`, {
    Authorization,
  });
  return res?.payload;
};

export const createPromo = async (body, Authorization = '') => {
  const res = await post(`${BASE_URL}/promos`, { ...body }, { Authorization });
  return res?.data?.payload;
};

export const getPromoShopItems = async (promoId, Authorization = '') => {
  const res = await get(`${BASE_URL}/promos/${promoId}/items/all`, {
    Authorization,
  });
  return res?.payload;
};

export const getPromoShopItemsOfWallet = async (promoId, walletId, Authorization = '') => {
  const res = await get(`${BASE_URL}/wallets/${walletId}/promos/${promoId}/items?filter=NONE`, {
    Authorization,
  });
  return res?.payload;
};

export const createPromoShopItem = async (promoId, body, Authorization = '') => {
  const res = await post(`${BASE_URL}/promos/${promoId}/items`, { ...body }, { Authorization });
  return res?.data?.payload;
};

export const deletePromoShopItem = async (promoId, itemId, Authorization = '') => {
  const res = await del(`${BASE_URL}/promos/${promoId}/items/${itemId}`, { Authorization });
  return res?.data?.payload;
};

export const updatePromoShopItem = async (promoId, itemId, body, Authorization = '') => {
  const res = await put(
    `${BASE_URL}/promos/${promoId}/items/${itemId}`,
    { ...body },
    { Authorization }
  );
  return res?.payload;
};

export const getRewardsOfItem = async (promoId, itemId, Authorization = '') => {
  const res = await get(`${BASE_URL}/promos/${promoId}/items/${itemId}/rewards`, {
    Authorization,
  });
  return res?.payload;
};

export const updateRewardsOfItem = async (promoId, itemId, body, Authorization = '') => {
  const res = await post(
    `${BASE_URL}/promos/${promoId}/items/${itemId}/rewards`,
    { ...body },
    { Authorization }
  );
  return res?.payload;
};

export const getRewardedBoxes = async (promoId, rewardId, Authorization = '') => {
  const res = await get(`${BASE_URL}/promos/${promoId}/rewards/${rewardId}/boxes`, {
    Authorization,
  });
  return res?.payload;
};

export const getBoxesByItem = async (promoId, itemId, Authorization = '') => {
  const res = await get(`${BASE_URL}/promos/${promoId}/items/${itemId}/boxes`, {
    Authorization,
  });
  return res?.payload;
};

export const createDozerCoin = async (walletId, dozerCoinAmount, Authorization = '') => {
  const res = await post(
    `${BASE_URL}/dozer-coins`,
    { walletAddress: walletId, coinAmounts: dozerCoinAmount },
    { Authorization }
  );
  return res?.data?.payload;
};

export const consumeAllFragments = async (walletId, body = {}, Authorization = '') => {
  const res = await post(
    `${BASE_URL}/admin/wallets/${walletId}/fragments/consume-all`,
    { ...body },
    { Authorization }
  );
  return res?.data?.payload;
};

export const getAllShopHours = async (promoId, Authorization = '') => {
  const res = await get(`${BASE_URL}/promos/${promoId}/shop-open-hours/all`, { Authorization });
  return res?.payload;
};

export const createShopHour = async (promoId, body, Authorization = '') => {
  const res = await post(
    `${BASE_URL}/promos/${promoId}/shop-open-hours`,
    { ...body },
    { Authorization }
  );
  return res?.data?.payload;
};

export const deleteShopHour = async (promoId, shopHourId, Authorization = '') => {
  const res = await del(`${BASE_URL}/promos/${promoId}/shop-open-hours/${shopHourId}`, {
    Authorization,
  });
  return res?.data?.payload;
};

export const updateShopHour = async (promoId, shopHourId, body, Authorization = '') => {
  const res = await put(
    `${BASE_URL}/promos/${promoId}/shop-open-hours/${shopHourId}`,
    { ...body },
    { Authorization }
  );
  return res?.data?.payload;
};

const fileToBase64 = file => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result.split(',')[1]);
    reader.onerror = reject;
  });
};

export const uploadItemImage = async (file, imageType, Authorization = '') => {
  try {
    const base64 = await fileToBase64(file);
    const res = await post(
      `${BASE_URL}/upload-image`,
      {
        image: base64,
        contentType: file.type,
        fileName: file.name,
        imageType,
      },
      { Authorization }
    );
    const imageUrl = res?.data?.payload?.imageUrl;
    if (!imageUrl) {
      throw new Error('Upload failed — no image URL returned.');
    }
    return imageUrl;
  } catch (error) {
    if (error.response?.status === 413) {
      throw new Error('File too large. Please use an image under 4.5MB.');
    }
    throw error;
  }
};
